import { Injectable } from '@angular/core';
import { api } from '@bayclubs/utils';
import { Observable } from 'rxjs';
import { security } from '../../models/security';
import { ApiHttpClient } from './api-http-client';

@Injectable()
export class CampsPriviligesApiService {

  constructor(private http: ApiHttpClient) { }

  public getPriviliges(): Observable<api.OperationResultValue<security.CampsSecurityContext>> {

    return this.http.get<api.OperationResultValue<security.CampsSecurityContext>>('privileges', true);
  }
}